var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "km878qewea",
    d: "M17.778 13.333c0 1.964-3.98 3.556-8.89 3.556C3.98 16.889 0 15.297 0 13.333c0-1.27 1.938-2.436 4.444-3.065.27.444.57.873.896 1.288-1.98.362-3.562 1.053-3.562 1.777 0 1.13 3.184 2.045 7.11 2.045 3.928 0 7.112-.915 7.112-2.045 0-.724-1.575-1.415-3.556-1.777.328-.415.628-.844.896-1.288 2.507.629 4.438 1.794 4.438 3.065m-8.89-7.11c-.98 0-1.777-.797-1.777-1.779 0-.98.797-1.777 1.778-1.777s1.778.796 1.778 1.777c0 .982-.797 1.778-1.778 1.778m0-6.222C6.434 0 4.444 1.778 4.444 4.444c0 3.556 1.905 6.704 4.445 8.89 2.54-2.186 4.444-5.334 4.444-8.89C13.333 1.778 11.344 0 8.89 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-309 -415) translate(105 119) translate(160 288) translate(44 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 12)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#km878qewea"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.9c3ec618b74b1b03f5c344c60819d9c9.svg";
export { ForwardRef as ReactComponent };